import React from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import uniqBy from 'lodash/uniqBy';

import { openModal } from 'features/utilsSlice';
import { ONLYFANS_NETWORK_ID } from 'utils/helpers';
import TriangleAlertIcon from 'public/icons/triangle-alert.svg';
import CheckInCircleIcon from 'public/icons/check-circle-green.svg';
import ChevronRightIcon from 'public/icons/chevron-right-circle.svg';
import styles from 'styles/components/profileVerification/VerificationAlert.module.scss';

const VerificationAlert = ({ inventories }) => {
  const dispatch = useDispatch();

  const influencerNetworks = uniqBy(
    inventories.map(inventory => inventory.influencer_network),
    'id'
  );

  return (
    <div className={styles.container}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className={styles.iconContainer}>
          <TriangleAlertIcon />
        </div>

        <h2>Attention required</h2>
      </div>

      <p>
        You have not verified your social platforms and will not be able to use GigSocial until this
        has been done:
      </p>

      <div className={styles.networks}>
        {influencerNetworks
          .filter(i => i.network.automatic_verification)
          .sort(
            (a, b) =>
              ['verified', 'pending_verification'].includes(b.status) -
              ['verified', 'pending_verification'].includes(a.status)
          )
          .map(influencerNetwork => (
            <div
              key={influencerNetwork.id}
              onClick={() => {
                if (['verified', 'pending_verification'].includes(influencerNetwork.status)) return;

                if (influencerNetwork.network_id === ONLYFANS_NETWORK_ID) {
                  dispatch(
                    openModal({
                      name: 'Influencer OnlyFans Verification',
                      data: { influencerNetworkId: influencerNetwork.id },
                    })
                  );
                } else {
                  dispatch(
                    openModal({
                      name: 'Inventory Edit',
                      data: {
                        step: 'Profile Verification',
                        influencerNetworkId: influencerNetwork.id,
                      },
                    })
                  );
                }
              }}
              className={clsx(
                styles.chip,
                {
                  [styles.whiteChip]: ['verified', 'pending_verification'].includes(
                    influencerNetwork.status
                  ),
                },
                {
                  [styles.redChip]: influencerNetwork.status === 'unverified',
                }
              )}
            >
              {influencerNetwork.network.name}{' '}
              {['verified', 'pending_verification'].includes(influencerNetwork.status) ? (
                <CheckInCircleIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default VerificationAlert;
